module.exports = __webpack_public_path__ + "fonts/0188899.ttf";